import Vue from 'vue';

//获取回话唯一id
function getUUID() {
  let uuid = sessionStorage.getItem('bury-uuid');
  if (!uuid) {
    uuid = new Date().getTime();
    sessionStorage.setItem('bury-uuid', uuid);
  }
  return uuid;
}

//埋点方法类
export default class Bury {
  //   ‌前端埋点可以收集的数据类型主要包括用户行为数据、应用性能数据、设备和环境数据、用户属性数据。‌

  // ‌用户行为数据‌：这包括页面浏览量、点击事件、表单提交、购买行为等。通过埋点，可以追踪用户在网站或应用中的具体操作，如点击了哪些链接、浏览了哪些页面、进行了哪些交互等。
  // ‌应用性能数据‌：涉及页面加载时间、API调用延迟、错误日志等。这些数据有助于了解应用的性能表现，发现潜在的性能瓶颈，进而优化用户体验。
  // ‌设备和环境数据‌：包括用户设备类型、操作系统、浏览器版本等。这些信息对于分析不同设备和环境下的用户体验至关重要，有助于开发者针对特定设备或操作系统进行优化。
  // ‌用户属性数据‌：例如用户ID、地理位置、用户角色等。这些数据有助于对用户进行细分，理解不同用户群体的行为特征，为个性化服务和营销策略提供依据。
  // 通过这些数据的收集和分析，可以帮助企业更好地理解用户需求和行为模式，优化产品设计和服务，提升用户体验和业务效果‌1
  static buryAdd = (dynamicInfo, el) => {
    let { functionType, logType, startData } = dynamicInfo;
    let buryId = new Date().valueOf() + '';
    const params = {
      userId: localStorage.getItem('userId'),
      customerId: localStorage.getItem('customerId'),
      source: sessionStorage.getItem('platform'), //来源端
      functionType: functionType, //数据类型
      logType: logType, //数据二级类型
      menuCode: window.location.host + window.location.pathname + window.location.hash, //菜单编码 (非必填)
      buryId: buryId,
      startTime: parseInt(new Date().valueOf()), //开始时间，对于一些请求类型以及页面切换类型有用到
      startData: startData && JSON.stringify(startData), //任意key-value值
      endTime: parseInt(new Date().valueOf()), //结束时间，对于一些请求类型以及页面切换类型有用到
      endData: null //任意key-value值
    };

    //写入缓存
    let burylogs = localStorage.getItem('burylogs');
    if (!burylogs) {
      burylogs = '[]';
    }
    let burylogArr = JSON.parse(burylogs);
    burylogArr.push(params);
    burylogs = JSON.stringify(burylogArr);
    localStorage.setItem('burylogs', burylogs);
    if (el) {
      el.classList.add('burylog');
      el.setAttribute('data-buryid', buryId);
    }

    return buryId;
  };
  static buryUpdateByEvent = (event, updateData) => {
    const targetBtn = event ? event.target.closest('.burylog') : null;
    if (!targetBtn) {
      return;
    }
    const buryId = targetBtn.dataset.buryid;

    console.log(buryId);

    //写入缓存
    let burylogs = localStorage.getItem('burylogs');
    if (!burylogs) {
      burylogs = '[]';
    }
    let burylogArr = JSON.parse(burylogs);

    for (let index = 0; index < burylogArr.length; index++) {
      if (burylogArr[index].buryId == buryId) {
        burylogArr[index].endTime = parseInt(new Date().valueOf());
        burylogArr[index].endData = updateData && JSON.stringify(updateData);
        break;
      }
    }

    burylogs = JSON.stringify(burylogArr);
    localStorage.setItem('burylogs', burylogs);
    this.uploadBuries();
  };
  static buryUpdateById = (buryId, updateData) => {
    //写入缓存
    let burylogs = localStorage.getItem('burylogs');
    if (!burylogs) {
      burylogs = '[]';
    }
    let burylogArr = JSON.parse(burylogs);

    for (let index = 0; index < burylogArr.length; index++) {
      if (burylogArr[index].buryId == buryId) {
        burylogArr[index].endTime = parseInt(new Date().valueOf());
        burylogArr[index].endData = updateData && JSON.stringify(updateData);
        break;
      }
    }

    burylogs = JSON.stringify(burylogArr);
    localStorage.setItem('burylogs', burylogs);

    this.uploadBuries();
  };

  static uploadBuries = () => {
    //写入缓存
    let burylogs = localStorage.getItem('burylogs');
    if (!burylogs) {
      return;
    }
    let burylogArr;
    try {
      burylogArr = JSON.parse(burylogs);
    } catch (error) {
      //这里重置为数组，其实是为了防止存了不是数组的格式进去导致不断增加
      burylogArr = [];
    }

    if (burylogArr.length >= 50) {
      //如果50条还上传不了，那肯定出问题了，为了防止堆积，直接清除
      localStorage.setItem('burylogs', '[]');
      return;
    }

    if (burylogArr.length >= 10) {
      Vue.prototype.http.post('/web/user/behavior/record/writeIn', burylogArr).then(res => {
        localStorage.setItem('burylogs', '[]');
      });
    }
  };
}
